<template>
  <div class="detail-dialog">
    <el-dialog title="学生行为详情" :visible.sync="behaviorDetailDialogShow" width="850px" :before-close="dialogClose"
      @open="dialogOpen">
      <!-- 学年学期 -->
      <el-form ref="ruleForm" label-width="100px" class="ruleForm" label-position="top" :inline="true">
        <el-form-item label="选择学年:" label-width="100px" prop="schoolYear">
          <el-input type="text" v-model="detailData.schoolYear"></el-input>
        </el-form-item>
        <el-form-item label="选择学期:" label-width="100px" prop="semester">
          <el-select v-model="detailData.semester" placeholder="请选择学期" style="width: 235px">
            <el-option v-for="item in semesterOptions" :key="item.dictValue" :label="item.dictLabel"
              :value="item.dictValue">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="记录时间:" label-width="100px" prop="recordTime">
          <el-date-picker style="width: 235px" v-model="detailData.recordTime" type="date" placeholder="请选择时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="班主任" prop="teacherChargeId">
          <el-input type="text" v-model="detailData.teacherChargeName"></el-input>
        </el-form-item>
        <el-form-item label="导师" prop="tutorId">
          <el-input type="text" v-model="detailData.tutorName"></el-input>
        </el-form-item>
      </el-form>
      <!-- 行为内容 -->
      <el-form ref="ruleForm" label-width="100px" class="ruleForm" label-position="top">
        <el-form-item label="奖惩情况" prop="behaviorContent">
          <el-input type="textarea" :autosize="{ minRows: 6, maxRows: 8 }" v-model="detailData.recordContent"
            :maxlength="maxlength" show-word-limit></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: [
    'behaviorDetailDialogShow',
    'detailData',
    'semesterOptions'
  ],
  data() {
    return {
      maxlength: 1000,
    };
  },
  methods: {
    // 开启弹窗
    dialogOpen() {

    },
    // 关闭弹出窗口
    dialogClose() {
      this.$emit("update:behaviorDetailDialogShow", false);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./behaviorDetailDialog.scss";
</style>